export const navAuthMenuItems = [
  {
    title: "WPS认证",
    link: "https://kos.wps.cn/activity/p/auth-center?frpo=edu_wps365_Navigation",
  },
  {
    title: "KOS认证",
    link: "https://kos.wps.cn/?frpo=edu_wps365_Navigation",
  },
  {
    title: "1+X认证",
    link: "http://www.wpsx.com.cn/",
  },
  {
    title: "计算机等级考试",
    link: "https://ncre.neea.edu.cn/",
  },
];
